export default __webpack_public_path__ + "static/media/Icon-5.5a027a38.gif";